import { getAllDeliveries } from "@/business/deliveries/application/getAllDeliveries";
import { getDeliveryById } from "@/business/deliveries/application/getDeliveryById";
import { Delivery } from "@/business/deliveries/domain/deliveries";
import { onMounted, ref, Ref, computed } from "vue";
import { useRouter } from "vue-router";

export function deliveriesUse() {
  const router = useRouter();
  const deliveries: Ref<Delivery[]> = ref([]);
  const query: Ref<string> = ref("");
  const showModalDeliveryDetail: Ref<boolean> = ref(false);
  const deliverySelected: Ref<Delivery | null> = ref(null);

  onMounted(async () => {
    await getDeliveriesFromApi();
  });

  async function goToDeliveryOption() {
    await router.push("/administrator/delivery");
  }

  async function getDeliveriesFromApi(): Promise<void> {
    deliveries.value = await getAllDeliveries.execute();
  }

  const filteredDeliveries = computed(() => {
    let result = deliveries.value;
    if (query.value.length > 0) {
      result = deliveries.value.filter((delivery) =>
        delivery.name.toLowerCase().includes(query.value.toLowerCase()) || delivery.client.toLowerCase().includes(query.value.toLowerCase())
      );
    }
    return result;
  });

  async function showSelectedDeliveryDetails(delivery: Delivery): Promise<void> {
    showModalDeliveryDetail.value = true;
    deliverySelected.value = await getDeliveryById.execute(delivery.deliveryId);
  }

  function hideSelectedDeliveryDetails(): void {
    showModalDeliveryDetail.value = false;
    deliverySelected.value = null;
  }


  return {
    goToDeliveryOption,
    query,
    deliveries,
    filteredDeliveries,
    showSelectedDeliveryDetails,
    hideSelectedDeliveryDetails,
    showModalDeliveryDetail,
    deliverySelected
  };
}
